import { trackOpenedModal } from '~/lib/analytics/actions/track'

const OPEN = 'modals/OPEN'
const CLOSE = 'modals/CLOSE'
const UPDATE_PAYLOAD = 'modals/UPDATE_PAYLOAD'

export default function modals(state = {}, action) {
    switch (action.type) {
        case OPEN:
            return {
                ...state,
                [action.name]: {
                    isOpen: true,
                    payload: action.payload,
                },
            }
        case CLOSE:
            return {
                ...state,
                [action.name]: {
                    isOpen: false,
                    payload: {},
                },
            }
        case UPDATE_PAYLOAD: {
            const modal = state[action.name]

            return {
                ...state,
                [action.name]: {
                    ...modal,
                    payload: {
                        ...modal.payload,
                        ...action.payload,
                    },
                },
            }
        }
        default:
            return state
    }
}

export function getModal(state, name) {
    return (
        state.modals[name] || {
            isOpen: false,
            payload: {},
        }
    )
}

export function openModal(name, payload = {}) {
    // instrument this
    return trackOpenedModal(
        {
            name,
            payload,
            type: OPEN,
        },
        { modalName: name },
    )
}

export function closeModal(name) {
    return {
        name,
        type: CLOSE,
    }
}
